<div class="obg-lotba-self-exclusion-alert-container">
	<div
		class="obg-lotba-self-exclusion-alert-header"
		test-id="self-exclusion-alert-container"
		data-test-id="self-exclusion-alert-container"
		(click)="closeDialog()"
	>
		<span class="close">&times;</span>
	</div>
	<div class="obg-lotba-self-exclusion-alert-content">
		<h1
			class="obg-lotba-self-exclusion-alert-title-text"
			*ngIf="data?.redirectButton || data?.footerRedirectButton"
		>
			{{ data?.title | translate }}
		</h1>
		<h3
			class="obg-lotba-self-exclusion-alert-title-text"
			*ngIf="!data?.redirectButton && !data?.footerRedirectButton"
		>
			{{ data?.title | translate }}
		</h3>
		<div class="obg-lotba-self-exclusion-alert-redirect-container" *ngIf="data?.redirectButton">
			<p>{{ data?.redirectInfo | translate }}</p>
			<a [obgRouteLink]="{ url: 'self-exclusion.realtime-alert.redirect-url' | translate }">
				{{ data?.redirectButton | translate }}
			</a>
		</div>
		<div class="obg-lotba-self-exclusion-alert-info-container">
			<a
				*ngIf="data?.footerRedirectButton"
				class="redirect-button"
				[obgRouteLink]="{ url: 'login-alert.login-limit.redirect-url' | translate }"
				target="_blank"
			>
				{{ data?.footerRedirectButton | translate }}
			</a>
			<p *ngIf="data?.info">{{ data.info | translate }}</p>
			<span class="fill"></span>
			<a *ngIf="icon$ | async as icon" [obgRouteLink]="{ url: icon?.link.url }" [target]="icon?.link?.target">
				<obg-lazy-image
					*ngIf="icon?.logo?.url"
					[attr.test-id]=" 'img_' + icon?.key"
					[src]="icon?.logo?.url"
					[alt]="icon?.logo?.altText"
				></obg-lazy-image>
			</a>
		</div>
	</div>
</div>
